// Sign-in analytics describe where the user was trying to go (the deep link saved before the
// login wall) without leaking record ids: /offer/<uuid>/HA/checkout -> /offer/:id/HA/checkout.
// A path segment is treated as an id when it is a UUID or contains 6+ digits.
const ID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$|\d{6,}/i;

export const describeDeepLink = (deepLink) => {
  if (!deepLink) {
    return { hasDeepLink: false };
  }
  try {
    const url = new URL(deepLink, window.location.origin);
    const deepLinkRoute = url.pathname
      .split('/')
      .map((segment) => (ID_SEGMENT.test(segment) ? ':id' : segment))
      .join('/');
    return {
      hasDeepLink: true,
      deepLinkRoute,
      // Comparative-rater bridge params (/offer/<id>?rater=ez&type=HA), when present
      deepLinkRater: url.searchParams.get('rater') || undefined,
      deepLinkOption: url.searchParams.get('type') || undefined
    };
  } catch {
    return { hasDeepLink: true };
  }
};
